export const shortenShopifyId = (shopifyId: string) => {
  // TODO: Fix this auto-generated suppression.
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return (shopifyId ?? '').split('/').pop() ?? shopifyId
}

export const shortenShopifyIdToNumeric = (shopifyId: string | undefined | null) => {
  if (!shopifyId || shopifyId.length === 0) return null
  const result = parseInt(shortenShopifyId(shopifyId), 10)
  return isNaN(result) ? null : result
}
